import { connect } from "react-redux";
import { useEffect, useState } from "react";
import {
	check_authenticated,
	load_user,
	refresh,
	reset_password,
} from "../../redux/actions/auth/auth";

import { Link, Navigate } from "react-router-dom";
import { IconMail } from "@tabler/icons-react";
import HomeLayout from "../../hocs/layout/HomeLayout";
import { Helmet } from "react-helmet-async";
import img_logo from "../../assets/img/logo.png"
function ResetPassword({
	reset_password,
	isAuthenticated,
	refresh,
	check_authenticated,
	load_user,
}) {
	useEffect(() => {
		isAuthenticated ? (
			<></>
		) : (
			<>
				{refresh()}
				{check_authenticated()}
				{load_user()}
			</>
		);
	}, [refresh, check_authenticated, load_user, isAuthenticated]);

	const [formData, setFormData] = useState({
		email: "",
	});

	const { email } = formData;

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });


	const onSubmit = (e) => {
		e.preventDefault();
		reset_password(email);
		
	};

	if (isAuthenticated) {
		return <Navigate to="/dashboard" />;
	}

	return (
		<HomeLayout>
			<Helmet>
				<title>Latir | Reinicio de Contraseña</title>
			</Helmet>
			<div className="flex min-h-full items-center justify-center py-56 px-10 sm:px-6 lg:px-8">
				<div className="w-full max-w-md space-y-8 bg-white shadow-lg p-4 rounded-lg">
					<div>
						<img
							className="mx-auto h-20 w-auto"
							src={img_logo}
							alt="Your Company"
						/>
					</div>
					<form
						onSubmit={(e) => {
							onSubmit(e);
						}}
						className="mt-8 space-y-6"
						method="POST"
					>
						<input type="hidden" name="remember" defaultValue="true" />
						<div className="-space-y-px">
							<div>
								<label htmlFor="email-address" className="sr-only">
									Email address
								</label>
								<input
									id="email-address"
									name="email"
									value={email}
									onChange={(e) => onChange(e)}
									type="email"
									required
									className="input input-bordered w-full border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-[#0096C4] focus:outline-none focus:ring-[#0096C4] sm:text-sm"
									placeholder="Dirección de correo"
								/>
							</div>
						</div>

						<div className="flex items-center justify-between">
							<div className="text-sm">
								<span className="">¿Posees una cuenta? </span>
								<Link
									to="/login"
									className="font-medium text-[#0096C4] hover:text-[#00496B]"
								>
									Inicia sesión
								</Link>
							</div>
						</div>

						<div>
							<button
								type="submit"
								className="group relative flex w-full justify-center rounded-md border border-transparent bg-[#0096C4] py-2 px-4 text-sm font-medium text-white hover:bg-[#00496B] focus:outline-none focus:ring-2 focus:ring-[#00496B] focus:ring-offset-2"
							>
								<span className="absolute inset-y-0 left-0 flex items-center pl-3">
									<IconMail
										className="h-5 w-5 text-white"
										aria-hidden="true"
									/>
								</span>
								Enviar Correo
							</button>
						</div>
					</form>
				</div>
			</div>
		</HomeLayout>
	);
}

const mapStateToProps = (state) => ({
	isAuthenticated: state.auth.isAuthenticated,
	loading: state.auth.loading,
});

export default connect(mapStateToProps, {
	reset_password,
	refresh,
	check_authenticated,
	load_user,
})(ResetPassword);
